import { render, staticRenderFns } from "./RelatorioTotal.vue?vue&type=template&id=4faaf678&scoped=true"
import script from "./RelatorioTotal.vue?vue&type=script&lang=js"
export * from "./RelatorioTotal.vue?vue&type=script&lang=js"
import style0 from "./RelatorioTotal.vue?vue&type=style&index=0&id=4faaf678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faaf678",
  null
  
)

export default component.exports